export default "__VITE_ASSET__L7oEsdlN__"